import { AbstractControl, ValidatorFn } from '@angular/forms';
import { LocationDataGeocoded } from '@sc/data-access-models';

export class AppointmentMobilityAddressValidator {
  static addressElementsConsistency(
    addrCheckFn: (loc: LocationDataGeocoded) => boolean
  ): ValidatorFn {
    const fn = (control: AbstractControl): { [key: string]: boolean } => {
      const interventionLocation: LocationDataGeocoded = control.get(
        'interventionLocation'
      )?.value;
      const isOutsideIntervention: boolean = control.get(
        'outsideIntervention'
      )?.value;

      if (isOutsideIntervention === true && !interventionLocation) {
        return {
          outside_without_addr: true,
        };
      }

      if (
        isOutsideIntervention === true &&
        !addrCheckFn(interventionLocation)
      ) {
        return {
          outside_addr_incomplete: true,
        };
      }

      return null;
    };

    return fn;
  }
}
